import { trendList } from '@/mocks/guatian';

const markStyle: Record<string, string> = {
  爆: 'bg-primary-500 text-background-50',
  热: 'bg-secondary-400 text-background-50',
  新: 'bg-accent-500 text-accent-950',
};

const iconByCat: Record<string, string> = {
  影视: 'ri-film-line',
  综艺: 'ri-mic-line',
  音乐: 'ri-music-2-line',
  商业: 'ri-store-2-line',
  趣闻: 'ri-emotion-laugh-line',
};

export default function TopTrending() {
  return (
    <section id="trending" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex items-end justify-between gap-3">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-fire-line" aria-hidden="true" /> 热度风向标
            </p>
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">今日热榜</h2>
          </div>
          <span className="hidden items-center gap-2 text-sm text-foreground-500 sm:flex">
            <i className="ri-refresh-line text-primary-500" aria-hidden="true" />
            每 10 分钟滚动更新
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {trendList.map((item, idx) => (
            <a
              key={item.id}
              href="#feed"
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100/60 p-4 transition hover:border-primary-200 hover:bg-background-50 md:p-5"
            >
              <span
                className={`font-heading w-9 shrink-0 text-center text-2xl ${
                  idx < 3 ? 'text-primary-500' : 'text-background-400'
                }`}
              >
                {String(idx + 1).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <div className="mb-1 flex items-center gap-2">
                  <span className={`inline-flex h-5 w-8 items-center justify-center rounded-full text-[11px] font-bold ${markStyle[item.mark]}`}>
                    {item.mark}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-accent-600">
                    <i className={`${iconByCat[item.category] || 'ri-film-line'}`} aria-hidden="true" />
                    {item.category}
                  </span>
                </div>
                <h3 className="truncate text-sm font-medium text-foreground-900 transition group-hover:text-primary-700 md:text-[15px]">
                  {item.title}
                </h3>
              </div>
              <span className="flex shrink-0 items-center gap-1 text-xs font-semibold text-primary-600">
                <i className="ri-flashlight-fill" aria-hidden="true" />
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}